<template>
  <app-widget
    actions
    class-widget="xs12"
  >
    <div slot="widget-content">
      <v-subheader
        class="font-weight-bold warning--text"
        v-text="`Vínculos cliente/empresa`"
      />
      <v-list
        two-line
        v-if="cliente.industrias.length > 0"
      >
        <v-list-item
          v-for="(item, i) in cliente.industrias"
          :key="i"
        >
          <v-list-item-avatar>
            <v-avatar
              :color="(!!item.pivot.contrato_inicio && !!item.pivot.contrato_fim)? 'secondary' : 'warning'"
              size="40"
            >
              <v-icon dark>
                apartment
              </v-icon>
            </v-avatar>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-text="`${item.nome_fantasia}`" />
            <v-list-item-subtitle class="grey--text caption font-weight-medium" v-text="getDatasDeContrato(item.pivot)" />
          </v-list-item-content>
          <v-list-item-action>
            <v-btn
              icon
              :disabled="!cliente.ativo"
              @click.prevent="editar(item.pivot.id)"
            >
              <v-icon color="warning lighten-1">
                edit
              </v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-list v-else>
        <v-list-item>
          <v-list-item-avatar>
            <v-icon class="black lighten-2 white--text">
              thumb_down
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-text="'Nenhum vínculo foi informado.'" />
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
    <div slot="widget-actions">
      <v-btn
        :disabled="!cliente.ativo"
        @click="adicionar()"
        color="warning darken-3"
      >
        Adicionar vínculo
      </v-btn>
    </div>
  </app-widget>
</template>

<script>
import { mapGetters } from 'vuex'
import AppWidget from '@/components/AppWidget'
export default {
  name: 'AppIndustriasCliente',
  components: {
    AppWidget
  },
  computed: {
    ...mapGetters(['cliente'])
  },
  methods: {
    getDatasDeContrato (pivot) {
      if (!!pivot.contrato_inicio && !!pivot.contrato_fim) {
        return `De ${this.$options.filters.date(
          pivot.contrato_inicio
        )} a ${this.$options.filters.date(pivot.contrato_fim)}`
      }
      return `Desde ${this.$options.filters.date(pivot.contrato_inicio)}`
    },
    editar (id) {
      if (this.cliente) {
        this.$router.push({
          name: 'clientes-industrias-update',
          params: {
            cliente_id: this.cliente.id,
            id
          }
        })
      }
    },
    adicionar () {
      if (this.cliente) {
        this.$router.push({
          name: 'clientes-industrias-create',
          params: {
            cliente_id: this.cliente.id
          }
        })
      }
    }
  }
}
</script>
